const saopaulo = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 26/27 - Uniforme 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2026",
      "2026 sao paulo",
      "são paulo 2025",
      "2026 são paulo",
      "2026",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/26-27-01/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/26-27-01/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/26-27-01/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/26-27-01/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 25/26 - Uniforme 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2025",
      "2025 sao paulo",
      "são paulo 2025",
      "2025 são paulo",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/25-26-01/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 25/26 - Calção 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2025",
      "2025 sao paulo",
      "são paulo 2025",
      "2025 são paulo",
      "2025",
      "calção são paulo",
      "calção sao paulo",
      "são paulo calção",
      "sao paulo calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/25-26-01-c/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01-c/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01-c/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01-c/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01-c/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 25/26 - Uniforme 1 (Feminina)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2025",
      "2025 sao paulo",
      "são paulo 2025",
      "2025 são paulo",
      "2025",
      "feminina",
      "feminina são paulo",
      "feminina sao paulo",
      "são paulo feminina ",
      "sao paulo feminina ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/25-26-01-f/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01-f/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01-f/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01-f/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-01-f/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 25/26 - Uniforme 2",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2025",
      "2025 sao paulo",
      "são paulo 2025",
      "2025 são paulo",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/25-26-02/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-02/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-02/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-02/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 25/26 - Uniforme 3",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2025",
      "2025 sao paulo",
      "são paulo 2025",
      "2025 são paulo",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/25-26-03/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-03/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-03/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-03/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 25/26 - Uniforme 3 (Feminina)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2025",
      "2025 sao paulo",
      "são paulo 2025",
      "2025 são paulo",
      "2025",
      "feminina",
      "feminina são paulo",
      "feminina sao paulo",
      "são paulo feminina ",
      "sao paulo feminina ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/25-26-03-f/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-03-f/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-03-f/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-03-f/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/25-26-03-f/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-01/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme 1 (Feminina)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
      "feminina",
      "feminina são paulo",
      "feminina sao paulo",
      "são paulo feminina ",
      "sao paulo feminina ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-01-f/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-f/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-f/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-f/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-f/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme 1 Manga Longa",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-01-mc/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-mc/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-mc/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-mc/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-mc/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Regata 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
      "regata",
      "regata sao paulo",
      "regata são paulo",
      "são paulo regata",
      "sao paulo regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-01-re/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-01-re/uni1.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme 2",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-02/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-02/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-02/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-02/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme 2 (Feminina)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
      "feminina",
      "feminina são paulo",
      "feminina sao paulo",
      "são paulo feminina ",
      "sao paulo feminina ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-02-f/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-02-f/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-02-f/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-02-f/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-02-f/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Regata 2",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
      "regata",
      "regata sao paulo",
      "regata são paulo",
      "são paulo regata",
      "sao paulo regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-02-re/uni0.jpeg",
      "/images/brasil/serie-a/saopaulo/24-25-02-re/uni1.jpeg",
      "/images/brasil/serie-a/saopaulo/24-25-02-re/uni2.jpeg",
      "/images/brasil/serie-a/saopaulo/24-25-02-re/uni3.jpeg",
      "/images/brasil/serie-a/saopaulo/24-25-02-re/uni4.jpeg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme 3",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-03/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-03/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-03/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-03/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme 3 (Feminina)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
      "feminina",
      "feminina são paulo",
      "feminina sao paulo",
      "são paulo feminina ",
      "sao paulo feminina ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-03-f/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-03-f/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-03-f/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-03-f/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-03-f/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme de Pré Jogo Black",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-05-pjb/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-05-pjb/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-05-pjb/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-05-pjb/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-05-pjb/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme de Treino (Preta)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2024",
      "2024 sao paulo",
      "são paulo 2024",
      "2024 são paulo",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/24-25-06-tp/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-06-tp/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/24-25-06-tp/uni2.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 23/24 - Uniforme 3",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2023",
      "2023 sao paulo",
      "são paulo 2023",
      "2023 são paulo",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/23-24-03/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/23-24-03/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/23-24-03/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/23-24-03/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/23-24-03/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 23/24 - Uniforme Edição Especial",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2023",
      "2023 sao paulo",
      "são paulo 2023",
      "2023 são paulo",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/23-24-00-esb/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/23-24-00-esb/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/23-24-00-esb/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/23-24-00-esb/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/23-24-00-esb/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 22/23 - Uniforme 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2022",
      "2022 sao paulo",
      "são paulo 2022",
      "2022 são paulo",
      "2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/22-23-01/uni0.jpeg",
      "/images/brasil/serie-a/saopaulo/22-23-01/uni1.jpeg",
      "/images/brasil/serie-a/saopaulo/22-23-01/uni2.jpeg",
      "/images/brasil/serie-a/saopaulo/22-23-01/uni3.jpeg",
      "/images/brasil/serie-a/saopaulo/22-23-01/uni4.jpeg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 24/25 - Uniforme 1 (Feminina)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2022",
      "2022 sao paulo",
      "são paulo 2022",
      "2022 são paulo",
      "2022",
      "feminina",
      "feminina são paulo",
      "feminina sao paulo",
      "são paulo feminina ",
      "sao paulo feminina ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/22-23-01-f/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/22-23-01-f/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/22-23-01-f/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/22-23-01-f/uni3.png",
      "/images/brasil/serie-a/saopaulo/22-23-01-f/uni4.png",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 22/23 - Calção 2",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2022",
      "2022 sao paulo",
      "são paulo 2022",
      "2022 são paulo",
      "2022",
      "calção são paulo",
      "calção sao paulo",
      "são paulo calção",
      "sao paulo calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/22-23-02-c/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/22-23-02-c/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/22-23-02-c/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/22-23-02-c/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/22-23-02-c/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 21/22 - Uniforme 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2021",
      "2021 sao paulo",
      "são paulo 2021",
      "2021 são paulo",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/21-22-01/uni0.png",
      "/images/brasil/serie-a/saopaulo/21-22-01/uni1.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 21/22 - Uniforme 2",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2021",
      "2021 sao paulo",
      "são paulo 2021",
      "2021 são paulo",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/21-22-02/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-02/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-02/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-02/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 21/22 - Uniforme 3",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2021",
      "2021 sao paulo",
      "são paulo 2021",
      "2021 são paulo",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/21-22-03/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-03/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-03/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-03/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 21/22 - Uniforme de Treino (Preta)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2021",
      "2021 sao paulo",
      "são paulo 2021",
      "2021 são paulo",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/21-22-05-tb/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-05-tb/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-05-tb/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-05-tb/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-05-tb/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 21/22 - Uniforme 1 (Feminina)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2021",
      "2021 sao paulo",
      "são paulo 2021",
      "2021 são paulo",
      "2021",
      "feminina",
      "feminina são paulo",
      "feminina sao paulo",
      "são paulo feminina ",
      "sao paulo feminina ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/21-22-01-f/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-01-f/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-01-f/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-01-f/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/21-22-01-f/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 20/21 - Uniforme Edição Especial (Rosa)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2020",
      "2020 sao paulo",
      "são paulo 2020",
      "2020 são paulo",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/20-21-00-eso/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-00-eso/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-00-eso/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-00-eso/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-00-eso/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 20/21 - Uniforme 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2020",
      "2020 sao paulo",
      "são paulo 2020",
      "2020 são paulo",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/20-21-01/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-01/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-01/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-01/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-01/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 20/21 - Uniforme 2",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2020",
      "2020 sao paulo",
      "são paulo 2020",
      "2020 são paulo",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/20-21-02/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-02/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-02/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-02/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-02/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 20/21 - Uniforme de Goleiro (Roxa)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2020",
      "2020 sao paulo",
      "são paulo 2020",
      "2020 são paulo",
      "2020",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/20-21-05-gr/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-05-gr/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-05-gr/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-05-gr/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-05-gr/uni4.jpg",
    ],
  },
  {
    id: 33,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 20/21 - Calção 1",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2020",
      "2020 sao paulo",
      "são paulo 2020",
      "2020 são paulo",
      "2020",
      "calção são paulo",
      "calção sao paulo",
      "são paulo calção",
      "sao paulo calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/20-21-01-c/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-01-c/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-01-c/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-01-c/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-01-c/uni4.jpg",
    ],
  },
  {
    id: 34,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 20/21 - Uniforme 2 (Feminina)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "sao paulo 2020",
      "2020 sao paulo",
      "são paulo 2020",
      "2020 são paulo",
      "2020",
      "feminina",
      "feminina são paulo",
      "feminina sao paulo",
      "são paulo feminina ",
      "sao paulo feminina ",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/saopaulo/20-21-02-f/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-02-f/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-02-f/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-02-f/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/20-21-02-f/uni4.jpg",
    ],
  },
  {
    id: 35,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 18/19 - Uniforme 1 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/18-19-01-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/18-19-01-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/18-19-01-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/18-19-01-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/18-19-01-rt/uni4.jpg",
    ],
  },
  {
    id: 36,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 06/07 - Uniforme 1 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/06-07-01-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/06-07-01-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/06-07-01-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/06-07-01-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/06-07-01-rt/uni4.jpg",
    ],
  },
  {
    id: 37,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 00/01 - Uniforme 1 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/00-01-01-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/00-01-01-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/00-01-01-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/00-01-01-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/00-01-01-rt/uni4.jpg",
    ],
  },
  {
    id: 38,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 00/01 - Uniforme 2 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/00-01-02-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/00-01-02-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/00-01-02-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/00-01-02-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/00-01-02-rt/uni4.jpg",
    ],
  },
  {
    id: 39,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 99/00 - Uniforme 1 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/99-00-01-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/99-00-01-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/99-00-01-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/99-00-01-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/99-00-01-rt/uni4.jpg",
    ],
  },
  {
    id: 40,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 96/97 - Uniforme 2 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/96-97-02-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/96-97-02-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/96-97-02-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/96-97-02-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/96-97-02-rt/uni4.jpg",
    ],
  },
  {
    id: 41,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 93/94 - Uniforme 1 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/93-94-01-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/93-94-01-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/93-94-02-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/93-94-01-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/93-94-01-rt/uni4.jpg",
    ],
  },
  {
    id: 42,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 93/94 - Uniforme 2 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/93-94-02-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/93-94-02-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/93-94-02-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/93-94-02-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/93-94-02-rt/uni4.jpg",
    ],
  },
  {
    id: 43,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo 91/92 - Uniforme 2 Retro",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "retro",
      "retro são paulo",
      "retro sao paulo",
      "são paulo retro ",
      "sao paulo retro ",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/91-92-02-rt/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/91-92-02-rt/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/91-92-02-rt/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/91-92-02-rt/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/91-92-02-rt/uni4.jpg",
    ],
  },
  {
    id: 44,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo - Jaqueta (Azul)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "jaqueta",
      "jaqueta são paulo",
      "jaqueta sao paulo",
      "são paulo jaqueta ",
      "sao paulo jaqueta ",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/ja/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/ja/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/ja/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/ja/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/ja/uni4.jpg",
    ],
  },
  {
    id: 45,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo - Jaqueta Coach (Branca)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "jaqueta",
      "jaqueta são paulo",
      "jaqueta sao paulo",
      "são paulo jaqueta ",
      "sao paulo jaqueta ",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/jcb/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/jcb/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/jcb/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/jcb/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/jcb/uni4.jpg",
    ],
  },
  {
    id: 46,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo - Jaqueta (Preta)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "jaqueta",
      "jaqueta são paulo",
      "jaqueta sao paulo",
      "são paulo jaqueta ",
      "sao paulo jaqueta ",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/jp/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/jp/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/jp/uni2.png",
      "/images/brasil/serie-a/saopaulo/jp/uni3.jpg",
      "/images/brasil/serie-a/saopaulo/jp/uni4.jpg",
    ],
  },
  {
    id: 47,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo - Jaqueta (Vermelha)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "jaqueta",
      "jaqueta são paulo",
      "jaqueta sao paulo",
      "são paulo jaqueta ",
      "sao paulo jaqueta ",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/jv/uni0.jpg",
      "/images/brasil/serie-a/saopaulo/jv/uni1.jpg",
      "/images/brasil/serie-a/saopaulo/jv/uni2.jpg",
      "/images/brasil/serie-a/saopaulo/jv/uni3.jpeg",
      "/images/brasil/serie-a/saopaulo/jv/uni4.jpeg",
    ],
  },
  {
    id: 48,
    pais: "brasil",
    liga: "serie-a",
    time: "sao-paulo",
    nome: "São Paulo - Jaqueta (Vermelha)",
    aliases: [
      "sao paulo",
      "são paulo",
      "tricolor",
      "jaqueta",
      "jaqueta são paulo",
      "jaqueta sao paulo",
      "são paulo jaqueta ",
      "sao paulo jaqueta ",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/saopaulo/jv1/uni0.jpeg",
      "/images/brasil/serie-a/saopaulo/jv1/uni1.jpeg",
      "/images/brasil/serie-a/saopaulo/jv1/uni2.jpeg",
      "/images/brasil/serie-a/saopaulo/jv1/uni3.jpeg",
      "/images/brasil/serie-a/saopaulo/jv1/uni4.jpeg",
    ],
  },
];

export default saopaulo;
